export default {
    "data": [{
        "shopmenu_id": "88",
        "company_id": 0,
        "name": "概况",
        "url": "/",
        "sort": 1,
        "is_menu": true,
        "pid": "0",
        "icon": "tachometer-alt",
        "is_show": true,
        "alias_name": "index",
        "version": 1,
        "disabled": false,
        "created": 1661939958,
        "updated": 1661939958,
        "menu_type": ["all"],
        "level": 1
    }, {
        "shopmenu_id": "89",
        "company_id": 0,
        "name": "商品",
        "url": "/entity",
        "sort": 2,
        "is_menu": true,
        "pid": "0",
        "icon": "shopping-bag",
        "is_show": true,
        "alias_name": "entity",
        "version": 1,
        "disabled": false,
        "created": 1661939958,
        "updated": 1686365755,
        "menu_type": ["all"],
        "level": 1,
        "isChildrenMenu": true,
        "children": [{
            "shopmenu_id": "90",
            "company_id": 0,
            "name": "商品管理",
            "url": "/entity/goods",
            "sort": 1,
            "is_menu": true,
            "pid": "89",
            "icon": null,
            "is_show": true,
            "alias_name": "goods",
            "version": 1,
            "disabled": false,
            "created": 1661939958,
            "updated": 1661939958,
            "menu_type": ["all"],
            "level": 2,
            "isChildrenMenu": true,
            "children": [{
                "shopmenu_id": "91",
                "company_id": 0,
                "name": "商品管理",
                "url": "/entity/goods/goodsphysical",
                "sort": 1,
                "is_menu": true,
                "pid": "90",
                "icon": null,
                "is_show": true,
                "alias_name": "goodsphysical",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1699344272,
                "menu_type": ["all"],
                "level": 3
            }, {
                "shopmenu_id": "10210",
                "company_id": 0,
                "name": "商家商品",
                "url": "/entity/goods/goodsaudit",
                "sort": 2,
                "is_menu": true,
                "pid": "90",
                "icon": null,
                "is_show": true,
                "alias_name": "goodsaudit",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1661939958,
                "menu_type": ["platform"],
                "level": 3
            }, {
                "shopmenu_id": "10680",
                "company_id": 0,
                "name": "直播商品",
                "url": "/entity/goods/livegoods",
                "sort": 3,
                "is_menu": true,
                "pid": "90",
                "icon": null,
                "is_show": true,
                "alias_name": "livegoods",
                "version": 1,
                "disabled": false,
                "created": 1680233641,
                "updated": 1680233668,
                "menu_type": ["all"],
                "level": 3
            }]
        }, {
            "shopmenu_id": "10547",
            "company_id": 0,
            "name": "基础配置",
            "url": "/entity/goodsbase",
            "sort": 2,
            "is_menu": true,
            "pid": "89",
            "icon": null,
            "is_show": true,
            "alias_name": "goodsbase",
            "version": 1,
            "disabled": false,
            "created": 1661939958,
            "updated": 1661939958,
            "menu_type": ["all"],
            "level": 2,
            "isChildrenMenu": true,
            "children": [{
                "shopmenu_id": "10550",
                "company_id": 0,
                "name": "销售分类",
                "url": "/entity/goodsbase/goodscategory",
                "sort": 1,
                "is_menu": true,
                "pid": "10547",
                "icon": null,
                "is_show": true,
                "alias_name": "goodscategory",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1661939958,
                "menu_type": ["all"],
                "level": 3
            }, {
                "shopmenu_id": "10551",
                "company_id": 0,
                "name": "管理分类",
                "url": "/entity/goodsbase/goodsmaincategory",
                "sort": 2,
                "is_menu": true,
                "pid": "10547",
                "icon": null,
                "is_show": true,
                "alias_name": "goodsmaincategory",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1662601691,
                "menu_type": ["all"],
                "level": 3
            }, {
                "shopmenu_id": "10552",
                "company_id": 0,
                "name": "商品规格",
                "url": "/entity/goodsbase/goodsattributes",
                "sort": 3,
                "is_menu": true,
                "pid": "10547",
                "icon": null,
                "is_show": true,
                "alias_name": "goodsattributes",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1666937282,
                "menu_type": ["all"],
                "level": 3
            }, {
                "shopmenu_id": "10553",
                "company_id": 0,
                "name": "商品品牌",
                "url": "/entity/goodsbase/goodsbrand",
                "sort": 4,
                "is_menu": true,
                "pid": "10547",
                "icon": null,
                "is_show": true,
                "alias_name": "goodsbrand",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1661939958,
                "menu_type": ["all"],
                "level": 3
            }, {
                "shopmenu_id": "10554",
                "company_id": 0,
                "name": "商品参数",
                "url": "/entity/goodsbase/goodsparams",
                "sort": 5,
                "is_menu": true,
                "pid": "10547",
                "icon": null,
                "is_show": true,
                "alias_name": "goodsparams",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1666937564,
                "menu_type": ["all"],
                "level": 3
            }, {
                "shopmenu_id": "10555",
                "company_id": 0,
                "name": "商品标签",
                "url": "/entity/goodsbase/itemtags",
                "sort": 6,
                "is_menu": true,
                "pid": "10547",
                "icon": null,
                "is_show": true,
                "alias_name": "itemtags",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1786008492,
                "menu_type": ["all"],
                "level": 3
            }, {
                "shopmenu_id": "10556",
                "company_id": 0,
                "name": "运费模板",
                "url": "/entity/goodsbase/shippingtemplates",
                "sort": 7,
                "is_menu": true,
                "pid": "10547",
                "icon": null,
                "is_show": true,
                "alias_name": "shippingtemplates",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1661939958,
                "menu_type": ["all"],
                "level": 3
            }]
        }, {
            "shopmenu_id": "10557",
            "company_id": 0,
            "name": "其他服务",
            "url": "/entity/service",
            "sort": 3,
            "is_menu": true,
            "pid": "89",
            "icon": null,
            "is_show": true,
            "alias_name": "service",
            "version": 1,
            "disabled": false,
            "created": 1661939958,
            "updated": 1661939958,
            "menu_type": ["all"],
            "level": 2,
            "isChildrenMenu": true,
            "children": [{
                "shopmenu_id": "10559",
                "company_id": 0,
                "name": "素材管理",
                "url": "/entity/service/brandmaterial",
                "sort": 2,
                "is_menu": true,
                "pid": "10557",
                "icon": null,
                "is_show": true,
                "alias_name": "brandmaterial",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1661939958,
                "menu_type": ["all"],
                "level": 3
            }]
        }]
    }, {
        "shopmenu_id": "104",
        "company_id": 0,
        "name": "交易",
        "url": "/order",
        "sort": 2,
        "is_menu": true,
        "pid": "0",
        "icon": "clipboard-list",
        "is_show": true,
        "alias_name": "order",
        "version": 1,
        "disabled": false,
        "created": 1661939958,
        "updated": 1661939958,
        "menu_type": ["all"],
        "level": 1,
        "isChildrenMenu": true,
        "children": [{
            "shopmenu_id": "94",
            "company_id": 0,
            "name": "实物订单",
            "url": "/order/entitytrade",
            "sort": 1,
            "is_menu": true,
            "pid": "104",
            "icon": null,
            "is_show": true,
            "alias_name": "entitytrade",
            "version": 1,
            "disabled": false,
            "created": 1661939958,
            "updated": 1662161958,
            "menu_type": ["all"],
            "level": 2,
            "isChildrenMenu": true,
            "children": [{
                "shopmenu_id": "95",
                "company_id": 0,
                "name": "全部订单",
                "url": "/order/entitytrade/tradenormalorders",
                "sort": 1,
                "is_menu": true,
                "pid": "94",
                "icon": null,
                "is_show": true,
                "alias_name": "tradenormalorders",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1762303802,
                "menu_type": ["all"],
                "level": 3
            }, {
                "shopmenu_id": "10009",
                "company_id": 0,
                "name": "售后列表",
                "url": "/order/entitytrade/aftersaleslist",
                "sort": 4,
                "is_menu": true,
                "pid": "94",
                "icon": null,
                "is_show": true,
                "alias_name": "aftersaleslist",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1661939958,
                "menu_type": ["b2c", "platform", "standard"],
                "level": 3
            }]
        }, {
            "shopmenu_id": "10275",
            "company_id": 0,
            "name": "交易单",
            "url": "/order/servicepayment",
            "sort": 2,
            "is_menu": true,
            "pid": "104",
            "icon": null,
            "is_show": true,
            "alias_name": "servicepayment",
            "version": 1,
            "disabled": false,
            "created": 1661939958,
            "updated": 1661939958,
            "menu_type": ["all"],
            "level": 2
        }, {
            "shopmenu_id": "10266",
            "company_id": 0,
            "name": "退款单",
            "url": "/order/aftersalesrefundlist",
            "sort": 4,
            "is_menu": true,
            "pid": "104",
            "icon": null,
            "is_show": true,
            "alias_name": "aftersalesrefundlist",
            "version": 1,
            "disabled": false,
            "created": 1661939958,
            "updated": 1661939958,
            "menu_type": ["all"],
            "level": 2
        }, {
            "shopmenu_id": "10229",
            "company_id": 0,
            "name": "退款失败",
            "url": "/order/Refunderrorlogs",
            "sort": 4,
            "is_menu": true,
            "pid": "104",
            "icon": null,
            "is_show": true,
            "alias_name": "order-Refunderrorlogs",
            "version": 1,
            "disabled": false,
            "created": 1661939958,
            "updated": 1661939958,
            "menu_type": ["all"],
            "level": 2
        }, {
            "shopmenu_id": "10115",
            "company_id": 0,
            "name": "订单时效",
            "url": "/order/Ordersetting",
            "sort": 7,
            "is_menu": true,
            "pid": "104",
            "icon": null,
            "is_show": true,
            "alias_name": "ordersetting",
            "version": 1,
            "disabled": false,
            "created": 1661939958,
            "updated": 1661939958,
            "menu_type": ["all"],
            "level": 2
        }, {
            "shopmenu_id": "10414",
            "company_id": 0,
            "name": "售后原因",
            "url": "/order/aftersalesreason",
            "sort": 10,
            "is_menu": true,
            "pid": "104",
            "icon": null,
            "is_show": true,
            "alias_name": "aftersalesreason",
            "version": 1,
            "disabled": false,
            "created": 1661939958,
            "updated": 1661939958,
            "menu_type": ["b2c", "platform", "standard"],
            "level": 2
        }]
    }, {
        "shopmenu_id": "116",
        "company_id": 0,
        "name": "会员",
        "url": "/member",
        "sort": 4,
        "is_menu": true,
        "pid": "0",
        "icon": "gem1",
        "is_show": true,
        "alias_name": "member",
        "version": 1,
        "disabled": false,
        "created": 1661939958,
        "updated": 1661939958,
        "menu_type": ["all"],
        "level": 1,
        "isChildrenMenu": true,
        "children": [{
            "shopmenu_id": "117",
            "company_id": 0,
            "name": "会员列表",
            "url": "/member/member",
            "sort": 0,
            "is_menu": true,
            "pid": "116",
            "icon": null,
            "is_show": true,
            "alias_name": "memberlist",
            "version": 1,
            "disabled": false,
            "created": 1661939958,
            "updated": 1762303837,
            "menu_type": ["all"],
            "level": 2,
            "isChildrenMenu": false,
            "children": [{
                "shopmenu_id": "10026",
                "company_id": 0,
                "name": "会员信息查看",
                "url": "/member/member",
                "sort": 1,
                "is_menu": false,
                "pid": "117",
                "icon": null,
                "is_show": true,
                "alias_name": "member-list-view",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1661939958,
                "menu_type": ["all"],
                "level": 3
            }, {
                "shopmenu_id": "10063",
                "company_id": 0,
                "name": "会员导出",
                "url": "/member/member",
                "sort": 1,
                "is_menu": false,
                "pid": "117",
                "icon": null,
                "is_show": true,
                "alias_name": "member-export",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1661939958,
                "menu_type": ["all"],
                "level": 3
            }, {
                "shopmenu_id": "10078",
                "company_id": 0,
                "name": "手动延期付费会员",
                "url": "/member/member",
                "sort": 1,
                "is_menu": false,
                "pid": "117",
                "icon": null,
                "is_show": true,
                "alias_name": "member-vip-delay",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1661939958,
                "menu_type": ["all"],
                "level": 3
            }, {
                "shopmenu_id": "10024",
                "company_id": 0,
                "name": "添加权益",
                "url": "/member/member",
                "sort": 2,
                "is_menu": false,
                "pid": "117",
                "icon": null,
                "is_show": true,
                "alias_name": "member-add-rights",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1661939958,
                "menu_type": ["all"],
                "level": 3
            }, {
                "shopmenu_id": "10027",
                "company_id": 0,
                "name": "群发优惠券",
                "url": "/member/member",
                "sort": 4,
                "is_menu": false,
                "pid": "117",
                "icon": null,
                "is_show": true,
                "alias_name": "member-send-coupons",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1661939958,
                "menu_type": ["all"],
                "level": 3
            }, {
                "shopmenu_id": "10028",
                "company_id": 0,
                "name": "群发短信",
                "url": "/member/member",
                "sort": 5,
                "is_menu": false,
                "pid": "117",
                "icon": null,
                "is_show": true,
                "alias_name": "member-send-sms",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1661939958,
                "menu_type": ["all"],
                "level": 3
            }, {
                "shopmenu_id": "10029",
                "company_id": 0,
                "name": "打标签",
                "url": "/member/member",
                "sort": 6,
                "is_menu": false,
                "pid": "117",
                "icon": null,
                "is_show": true,
                "alias_name": "member-tag",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1661939958,
                "menu_type": ["all"],
                "level": 3
            }, {
                "shopmenu_id": "10030",
                "company_id": 0,
                "name": "会员手机号修改",
                "url": "/member/member",
                "sort": 7,
                "is_menu": false,
                "pid": "117",
                "icon": null,
                "is_show": true,
                "alias_name": "member-modify-phone-number",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1661939958,
                "menu_type": ["all"],
                "level": 3
            }]
        }, {
            "shopmenu_id": "10130",
            "company_id": 0,
            "name": "积分规则",
            "url": "/member/pointrule",
            "sort": 2,
            "is_menu": true,
            "pid": "116",
            "icon": null,
            "is_show": true,
            "alias_name": "pointrule",
            "version": 1,
            "disabled": false,
            "created": 1661939958,
            "updated": 1661939958,
            "menu_type": ["all"],
            "level": 2
        }, {
            "shopmenu_id": "10398",
            "company_id": 0,
            "name": "积分总览",
            "url": "/member/pointoverview",
            "sort": 3,
            "is_menu": true,
            "pid": "116",
            "icon": null,
            "is_show": true,
            "alias_name": "pointoverview",
            "version": 1,
            "disabled": false,
            "created": 1661939958,
            "updated": 1661939958,
            "menu_type": ["all"],
            "level": 2
        }, {
            "shopmenu_id": "121",
            "company_id": 0,
            "name": "会员标签",
            "url": "/member/Managetag",
            "sort": 4,
            "is_menu": true,
            "pid": "116",
            "icon": null,
            "is_show": true,
            "alias_name": "Managetag",
            "version": 1,
            "disabled": false,
            "created": 1661939958,
            "updated": 1661939958,
            "menu_type": ["all"],
            "level": 2
        }, {
            "shopmenu_id": "122",
            "company_id": 0,
            "name": "客户注册",
            "url": "/member/Manageinfomation",
            "sort": 7,
            "is_menu": true,
            "pid": "116",
            "icon": null,
            "is_show": true,
            "alias_name": "manageinfomation",
            "version": 1,
            "disabled": false,
            "created": 1661939958,
            "updated": 1661939958,
            "menu_type": ["all"],
            "level": 2
        }, {
            "shopmenu_id": "10486",
            "company_id": 0,
            "name": "客户注销",
            "url": "/member/closeAccount",
            "sort": 8,
            "is_menu": true,
            "pid": "116",
            "icon": null,
            "is_show": true,
            "alias_name": "closeAccount",
            "version": 1,
            "disabled": false,
            "created": 1661939958,
            "updated": 1661939958,
            "menu_type": ["all"],
            "level": 2
        }]
    }, {
        "shopmenu_id": "136",
        "company_id": 0,
        "name": "装修",
        "url": "/wxapp",
        "sort": 4,
        "is_menu": true,
        "pid": "0",
        "icon": "brush",
        "is_show": true,
        "alias_name": "wxapp-template",
        "version": 1,
        "disabled": false,
        "created": 1661939958,
        "updated": 1762821005,
        "menu_type": ["all"],
        "level": 1,
        "isChildrenMenu": true,
        "children": [{
            "shopmenu_id": "10054",
            "company_id": 0,
            "name": "微信小程序",
            "url": "/wxapp/manage",
            "sort": 1,
            "is_menu": true,
            "pid": "136",
            "icon": null,
            "is_show": true,
            "alias_name": "wxappmanage",
            "version": 1,
            "disabled": false,
            "created": 1661939958,
            "updated": 1777442304,
            "menu_type": ["all"],
            "level": 2,
            "isChildrenMenu": true,
            "children": [{
                "shopmenu_id": "10055",
                "company_id": 0,
                "name": "首页模板",
                "url": "/wxapp/manage/templateedit",
                "sort": 1,
                "is_menu": true,
                "pid": "10054",
                "icon": null,
                "is_show": true,
                "alias_name": "wxapp-template-edit",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1777442328,
                "menu_type": ["all"],
                "level": 3
            }, {
                "shopmenu_id": "10206",
                "company_id": 0,
                "name": "自定义页面",
                "url": "/wxapp/manage/custompage",
                "sort": 3,
                "is_menu": true,
                "pid": "10054",
                "icon": null,
                "is_show": true,
                "alias_name": "wxapp-custompage",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1661939958,
                "menu_type": ["all"],
                "level": 3
            }, {
                "shopmenu_id": "10264",
                "company_id": 0,
                "name": "风格配色",
                "url": "/wxapp/manage/colorstyle",
                "sort": 5,
                "is_menu": true,
                "pid": "10054",
                "icon": null,
                "is_show": true,
                "alias_name": "colorstyle",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1661939958,
                "menu_type": ["all"],
                "level": 3
            }, {
                "shopmenu_id": "10416",
                "company_id": 0,
                "name": "会员中心",
                "url": "/wxapp/manage/membercentersetting",
                "sort": 6,
                "is_menu": true,
                "pid": "10054",
                "icon": null,
                "is_show": true,
                "alias_name": "membercentersetting",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1661939958,
                "menu_type": ["all"],
                "level": 3
            }, {
                "shopmenu_id": "10672",
                "company_id": 0,
                "name": "店铺信息",
                "url": "/wxapp/manage/wxshopsetting",
                "sort": 6,
                "is_menu": true,
                "pid": "10054",
                "icon": null,
                "is_show": true,
                "alias_name": "wxshopsetting",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1786065928,
                "menu_type": ["all"],
                "level": 3
            }]
        }]
    }, {
        "shopmenu_id": "10285",
        "company_id": 0,
        "name": "商家",
        "url": "/sellers",
        "sort": 5,
        "is_menu": true,
        "pid": "0",
        "icon": "store-alt",
        "is_show": true,
        "alias_name": "sellers",
        "version": 1,
        "disabled": false,
        "created": 1661939958,
        "updated": 1661939958,
        "menu_type": ["platform"],
        "level": 1,
        "isChildrenMenu": true,
        "children": [{
            "shopmenu_id": "10287",
            "company_id": 0,
            "name": "商家管理",
            "url": "/sellers/storemanager",
            "sort": 1,
            "is_menu": true,
            "pid": "10285",
            "icon": null,
            "is_show": true,
            "alias_name": "sellersmanager",
            "version": 1,
            "disabled": false,
            "created": 1661939958,
            "updated": 1762739345,
            "menu_type": ["platform"],
            "level": 2,
            "isChildrenMenu": true,
            "children": [{
                "shopmenu_id": "10534",
                "company_id": 0,
                "name": "商家管理",
                "url": "/sellers/storemanager/list",
                "sort": 1,
                "is_menu": true,
                "pid": "10287",
                "icon": null,
                "is_show": true,
                "alias_name": "storemanager",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1777367065,
                "menu_type": ["platform"],
                "level": 3
            }, {
                "shopmenu_id": "10288",
                "company_id": 0,
                "name": "店铺管理",
                "url": "/sellers/storemanager/marketingdistributor",
                "sort": 2,
                "is_menu": true,
                "pid": "10287",
                "icon": null,
                "is_show": true,
                "alias_name": "marketingsellers",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1762739482,
                "menu_type": ["platform"],
                "level": 3
            }, {
                "shopmenu_id": "10295",
                "company_id": 0,
                "name": "售后地址",
                "url": "/sellers/storemanager/distributoraftersalesaddress",
                "sort": 3,
                "is_menu": true,
                "pid": "10287",
                "icon": null,
                "is_show": true,
                "alias_name": "distributoraftersalesaddress",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1661939958,
                "menu_type": ["platform"],
                "level": 3
            }, {
                "shopmenu_id": "10290",
                "company_id": 0,
                "name": "店铺标签",
                "url": "/sellers/storemanager/distributortags",
                "sort": 4,
                "is_menu": true,
                "pid": "10287",
                "icon": null,
                "is_show": true,
                "alias_name": "Sellerstags",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1661939958,
                "menu_type": ["platform"],
                "level": 3
            }, {
                "shopmenu_id": "10510",
                "company_id": 0,
                "name": "入驻审核",
                "url": "/sellers/storemanager/application",
                "sort": 5,
                "is_menu": true,
                "pid": "10287",
                "icon": null,
                "is_show": true,
                "alias_name": "storemanager_application",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1678671433,
                "menu_type": ["platform"],
                "level": 3
            }, {
                "shopmenu_id": "10511",
                "company_id": 0,
                "name": "商家设置",
                "url": "/sellers/storemanager/setting",
                "sort": 6,
                "is_menu": true,
                "pid": "10287",
                "icon": null,
                "is_show": true,
                "alias_name": "storemanager_setting",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1662011776,
                "menu_type": ["platform"],
                "level": 3
            }]
        }]
    }, {
        "shopmenu_id": "125",
        "company_id": 0,
        "name": "营销",
        "url": "/marketing",
        "sort": 7,
        "is_menu": true,
        "pid": "0",
        "icon": "gift",
        "is_show": true,
        "alias_name": "marketing",
        "version": 1,
        "disabled": false,
        "created": 1661939958,
        "updated": 1661939958,
        "menu_type": ["all"],
        "level": 1,
        "isChildrenMenu": true,
        "children": [{
            "shopmenu_id": "10709",
            "company_id": 0,
            "name": "抽奖",
            "url": "/marketing/lottery",
            "sort": 1,
            "is_menu": true,
            "pid": "125",
            "icon": null,
            "is_show": true,
            "alias_name": "lottery",
            "version": 1,
            "disabled": false,
            "created": 1773794356,
            "updated": 1784539987,
            "menu_type": ["all"],
            "level": 2
        }, {
            "shopmenu_id": "10711",
            "company_id": 0,
            "name": "抽奖设置",
            "url": "/marketing/lotterySet",
            "sort": 1,
            "is_menu": false,
            "pid": "125",
            "icon": null,
            "is_show": true,
            "alias_name": "lotterySet",
            "version": 1,
            "disabled": false,
            "created": 1774320637,
            "updated": 1784540299,
            "menu_type": ["all"],
            "level": 2
        }]
    }, {
        "shopmenu_id": "10086",
        "company_id": 0,
        "name": "财务",
        "url": "/financial",
        "sort": 9,
        "is_menu": true,
        "pid": "0",
        "icon": "file-invoice-dollar",
        "is_show": true,
        "alias_name": "financial",
        "version": 1,
        "disabled": false,
        "created": 1661939958,
        "updated": 1661939958,
        "menu_type": ["all"],
        "level": 1,
        "isChildrenMenu": true,
        "children": [{
            "shopmenu_id": "10091",
            "company_id": 0,
            "name": "营收明细",
            "url": "/financial/financialManage",
            "sort": 1,
            "is_menu": true,
            "pid": "10086",
            "icon": null,
            "is_show": true,
            "alias_name": "financialManage",
            "version": 1,
            "disabled": false,
            "created": 1661939958,
            "updated": 1661939958,
            "menu_type": ["all"],
            "level": 2,
            "isChildrenMenu": true,
            "children": [{
                "shopmenu_id": "10088",
                "company_id": 0,
                "name": "交易单",
                "url": "/financial/financialManage/servicepayment",
                "sort": 1,
                "is_menu": true,
                "pid": "10091",
                "icon": null,
                "is_show": true,
                "alias_name": "financialManageservicepayment",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1661939958,
                "menu_type": ["all"],
                "level": 3
            }, {
                "shopmenu_id": "10293",
                "company_id": 0,
                "name": "退款单",
                "url": "/financial/financialManage/aftersalesrefundlist",
                "sort": 2,
                "is_menu": true,
                "pid": "10091",
                "icon": null,
                "is_show": true,
                "alias_name": "financialFinancialManageAftersalesrefundlist",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1661939958,
                "menu_type": ["all"],
                "level": 3
            }, {
                "shopmenu_id": "10399",
                "company_id": 0,
                "name": "售后单",
                "url": "/financial/financialManage/financialaftersaleslist",
                "sort": 3,
                "is_menu": true,
                "pid": "10091",
                "icon": null,
                "is_show": true,
                "alias_name": "financialFinancialManageAftersaleslist",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1661939958,
                "menu_type": ["all"],
                "level": 3
            }]
        }]
    }, {
        "shopmenu_id": "10191",
        "company_id": 0,
        "name": "统计",
        "url": "/companydata",
        "sort": 10,
        "is_menu": true,
        "pid": "0",
        "icon": "chart-bar",
        "is_show": true,
        "alias_name": "companydata",
        "version": 1,
        "disabled": false,
        "created": 1661939958,
        "updated": 1661939958,
        "menu_type": ["all"],
        "level": 1,
        "isChildrenMenu": true,
        "children": [{
            "shopmenu_id": "10192",
            "company_id": 0,
            "name": "商品统计",
            "url": "/companydata/goodsstatistics",
            "sort": 1,
            "is_menu": true,
            "pid": "10191",
            "icon": null,
            "is_show": true,
            "alias_name": "goodsstatistics",
            "version": 1,
            "disabled": false,
            "created": 1661939958,
            "updated": 1661939958,
            "menu_type": ["all"],
            "level": 2
        }, {
            "shopmenu_id": "10195",
            "company_id": 0,
            "name": "交易统计",
            "url": "/companydata/orderstatistics",
            "sort": 2,
            "is_menu": true,
            "pid": "10191",
            "icon": null,
            "is_show": true,
            "alias_name": "orderstatistics",
            "version": 1,
            "disabled": false,
            "created": 1661939958,
            "updated": 1661939958,
            "menu_type": ["all"],
            "level": 2
        }, {
            "shopmenu_id": "10198",
            "company_id": 0,
            "name": "会员统计",
            "url": "/companydata/memberstatistics",
            "sort": 3,
            "is_menu": true,
            "pid": "10191",
            "icon": null,
            "is_show": true,
            "alias_name": "member-statistics",
            "version": 1,
            "disabled": false,
            "created": 1661939958,
            "updated": 1661939958,
            "menu_type": ["all"],
            "level": 2
        }, {
            "shopmenu_id": "10214",
            "company_id": 0,
            "name": "店铺统计",
            "url": "/companydata/distributordata",
            "sort": 4,
            "is_menu": true,
            "pid": "10191",
            "icon": null,
            "is_show": true,
            "alias_name": "distributordata",
            "version": 1,
            "disabled": false,
            "created": 1661939958,
            "updated": 1661939958,
            "menu_type": ["platform", "standard", "all"],
            "level": 2
        }, {
            "shopmenu_id": "10705",
            "company_id": 0,
            "name": "店铺数据汇总",
            "url": "/companydata/store-data-summary",
            "sort": 5,
            "is_menu": true,
            "pid": "10191",
            "icon": null,
            "is_show": true,
            "alias_name": "store-data-summary",
            "version": 1,
            "disabled": false,
            "created": 1759975630,
            "updated": 1762302358,
            "menu_type": ["all"],
            "level": 2
        }, {
            "shopmenu_id": "10712",
            "company_id": 0,
            "name": "分销统计",
            "url": "/companydata/distribution-statistics",
            "sort": 6,
            "is_menu": true,
            "pid": "10191",
            "icon": null,
            "is_show": true,
            "alias_name": "distribution-statistics",
            "version": 1,
            "disabled": false,
            "created": 1780293195,
            "updated": 1780880241,
            "menu_type": ["all"],
            "level": 2
        }]
    }, {
        "shopmenu_id": "137",
        "company_id": 0,
        "name": "设置",
        "url": "/setting",
        "sort": 13,
        "is_menu": true,
        "pid": "0",
        "icon": "cog",
        "is_show": true,
        "alias_name": "setting",
        "version": 1,
        "disabled": false,
        "created": 1661939958,
        "updated": 1661939958,
        "menu_type": ["all"],
        "level": 1,
        "isChildrenMenu": true,
        "children": [{
            "shopmenu_id": "10080",
            "company_id": 0,
            "name": "导出列表",
            "url": "/setting/baseexport",
            "sort": 20,
            "is_menu": true,
            "pid": "137",
            "icon": null,
            "is_show": true,
            "alias_name": "baseexport",
            "version": 1,
            "disabled": false,
            "created": 1661939958,
            "updated": 1661939958,
            "menu_type": ["all"],
            "level": 2
        }]
    }, {
        "shopmenu_id": "111",
        "company_id": 0,
        "name": "水电工",
        "url": "/shuidiangong",
        "sort": 2,
        "is_menu": true,
        "pid": "0",
        "icon": "shopping-bag",
        "is_show": true,
        "alias_name": "shuidiangong",
        "version": 1,
        "disabled": false,
        "created": 1661939958,
        "updated": 1686365755,
        "menu_type": ["all"],
        "level": 1,
        "isChildrenMenu": true,
        "children": [{
            "shopmenu_id": "90",
            "company_id": 0,
            "name": "运营总览",
            "url": "/shuidiangong/overview",
            "sort": 1,
            "is_menu": true,
            "pid": "111",
            "icon": null,
            "is_show": true,
            "alias_name": "overview",
            "version": 1,
            "disabled": false,
            "created": 1661939958,
            "updated": 1661939958,
            "menu_type": ["all"],
            "level": 2,
            "isChildrenMenu": true,
            "children": [{
                "shopmenu_id": "91",
                "company_id": 0,
                "name": "数据看板",
                "url": "/shuidiangong/overview/dashboard",
                "sort": 1,
                "is_menu": true,
                "pid": "90",
                "icon": null,
                "is_show": true,
                "alias_name": "overviewdashboard",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1699344272,
                "menu_type": ["all"],
                "level": 3
            }]
        }, {
            "shopmenu_id": "92",
            "company_id": 0,
            "name": "水电工管理",
            "url": "/shuidiangong/management",
            "sort": 2,
            "is_menu": true,
            "pid": "111",
            "icon": null,
            "is_show": true,
            "alias_name": "management",
            "version": 1,
            "disabled": false,
            "created": 1661939958,
            "updated": 1661939958,
            "menu_type": ["all"],
            "level": 2,
            "isChildrenMenu": true,
            "children": [{
                "shopmenu_id": "93",
                "company_id": 0,
                "name": "水电工审核",
                "url": "/shuidiangong/management/audit",
                "sort": 1,
                "is_menu": true,
                "pid": "92",
                "icon": null,
                "is_show": true,
                "alias_name": "managementaudit",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1699344272,
                "menu_type": ["all"],
                "level": 3
            }, {
                "shopmenu_id": "94",
                "company_id": 0,
                "name": "水电工管理",
                "url": "/shuidiangong/management/passed",
                "sort": 2,
                "is_menu": true,
                "pid": "92",
                "icon": null,
                "is_show": true,
                "alias_name": "managementpassed",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1699344272,
                "menu_type": ["all"],
                "level": 3
            }]
        }, {
            "shopmenu_id": "102",
            "company_id": 0,
            "name": "门店管理",
            "url": "/shuidiangong/store",
            "sort": 3,
            "is_menu": true,
            "pid": "111",
            "icon": null,
            "is_show": true,
            "alias_name": "store",
            "version": 1,
            "disabled": false,
            "created": 1661939958,
            "updated": 1661939958,
            "menu_type": ["all"],
            "level": 2,
            "isChildrenMenu": true,
            "children": [{
                "shopmenu_id": "103",
                "company_id": 0,
                "name": "门店列表/开通",
                "url": "/shuidiangong/store/list",
                "sort": 1,
                "is_menu": true,
                "pid": "102",
                "icon": null,
                "is_show": true,
                "alias_name": "storelist",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1699344272,
                "menu_type": ["all"],
                "level": 3
            }]
        }, {
            "shopmenu_id": "95",
            "company_id": 0,
            "name": "活动管理",
            "url": "/shuidiangong/activity",
            "sort": 4,
            "is_menu": true,
            "pid": "111",
            "icon": null,
            "is_show": true,
            "alias_name": "activity",
            "version": 1,
            "disabled": false,
            "created": 1661939958,
            "updated": 1661939958,
            "menu_type": ["all"],
            "level": 2,
            "isChildrenMenu": true,
            "children": [{
                "shopmenu_id": "96",
                "company_id": 0,
                "name": "活动列表",
                "url": "/shuidiangong/activity/list",
                "sort": 1,
                "is_menu": true,
                "pid": "95",
                "icon": null,
                "is_show": true,
                "alias_name": "activitylist",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1699344272,
                "menu_type": ["all"],
                "level": 3
            }, {
                "shopmenu_id": "97",
                "company_id": 0,
                "name": "活动设置",
                "url": "/shuidiangong/activity/setting",
                "sort": 2,
                "is_menu": true,
                "pid": "95",
                "icon": null,
                "is_show": true,
                "alias_name": "activitysetting",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1699344272,
                "menu_type": ["all"],
                "level": 3
            }, {
                "shopmenu_id": "98",
                "company_id": 0,
                "name": "二维码管理",
                "url": "/shuidiangong/activity/qrcode",
                "sort": 3,
                "is_menu": true,
                "pid": "95",
                "icon": null,
                "is_show": true,
                "alias_name": "activityqrcode",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1699344272,
                "menu_type": ["all"],
                "level": 3
            }]
        }, {
            "shopmenu_id": "104",
            "company_id": 0,
            "name": "邀请红包",
            "url": "/shuidiangong/invite",
            "sort": 5,
            "is_menu": true,
            "pid": "111",
            "icon": null,
            "is_show": true,
            "alias_name": "invite",
            "version": 1,
            "disabled": false,
            "created": 1661939958,
            "updated": 1661939958,
            "menu_type": ["all"],
            "level": 2,
            "isChildrenMenu": true,
            "children": [{
                "shopmenu_id": "105",
                "company_id": 0,
                "name": "邀请红包记录",
                "url": "/shuidiangong/invite/list",
                "sort": 1,
                "is_menu": true,
                "pid": "104",
                "icon": null,
                "is_show": true,
                "alias_name": "invitelist",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1699344272,
                "menu_type": ["all"],
                "level": 3
            }]
        }, {
            "shopmenu_id": "99",
            "company_id": 0,
            "name": "微信支付",
            "url": "/shuidiangong/payment",
            "sort": 6,
            "is_menu": true,
            "pid": "111",
            "icon": null,
            "is_show": true,
            "alias_name": "payment",
            "version": 1,
            "disabled": false,
            "created": 1661939958,
            "updated": 1661939958,
            "menu_type": ["all"],
            "level": 2,
            "isChildrenMenu": true,
            "children": [{
                "shopmenu_id": "100",
                "company_id": 0,
                "name": "微信商户号",
                "url": "/shuidiangong/payment/merchant",
                "sort": 1,
                "is_menu": true,
                "pid": "99",
                "icon": null,
                "is_show": true,
                "alias_name": "paymentmerchant",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1699344272,
                "menu_type": ["all"],
                "level": 3
            }, {
                "shopmenu_id": "101",
                "company_id": 0,
                "name": "支付流水",
                "url": "/shuidiangong/payment/flow",
                "sort": 2,
                "is_menu": true,
                "pid": "99",
                "icon": null,
                "is_show": true,
                "alias_name": "paymentflow",
                "version": 1,
                "disabled": false,
                "created": 1661939958,
                "updated": 1699344272,
                "menu_type": ["all"],
                "level": 3
            }]
        }]
    }]

}
